<div class="field field-select">
  @if (label) {
    <span class="label" [class.hide-text]="hideLabel">{{label}} @if (optionalString) {
      <span>({{optionalString}})</span>
    }</span>
  }
  <select
    [ngModel]="model"
    (ngModelChange)="modelChange.emit($event)"
    [class.model-empty]="model !== false && !model"
    [class.error-field]="error"
    [ngStyle]="{'max-width': maxWidth ? (maxWidth + 'px') : 'auto'}"
    [disabled]="disabled"
    >
    @if (withGroups) {
      @for (group of localGroupedOptions; track group) {
        @if (!group.options) {
          <option [ngValue]="group.value">{{ group.title }}</option>
        }
        @if (group.options) {
          <optgroup [label]="group.title">
            @for (option of group.options; track option) {
              <option [ngValue]="option.value">{{option.title}}</option>
            }
          </optgroup>
        }
      }
    } @else {
      @for (option of localOptions; track option) {
        <option [ngValue]="option.value">{{option.title}}</option>
      }
    }
  </select>
  @if (error && error !== 'true') {
    <span class="error-field-display">{{error}}</span>
  }
</div>